import type { PropsWithChildren } from 'react';

import { Logo } from '~/components/icons/logo.tsx';
import { cn } from '~/utils/cn.ts';

export function AuthLayout({ children }: PropsWithChildren) {
	return (
		<div className={cn('flex h-dvh w-dvw p-2 sm:p-4')}>
			<div className="flex h-full w-full items-center justify-center md:pb-[70px]">
				<div
					className={cn(
						'flex h-fit min-w-96 flex-col rounded-sm bg-card px-4 pt-4 pb-6 shadow-2xl sm:px-8',
						'w-9/10 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5',
					)}
				>
					<div className="mt-4 flex flex-row items-center justify-center py-2 text-foreground">
						<h1 className="flex py-1 pr-2 pb-2 font-extralight font-sans text-4xl">EQITY</h1>
						<Logo className="text-foreground" fill="currentColor" height={32} width={32} />
					</div>
					{children}
				</div>
			</div>
		</div>
	);
}
